export default __webpack_public_path__ + "static/media/laravel.a6d8dc52.svg";